import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'

import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'app-edgar-info-summary',
  templateUrl: './edgar-info-summary.component.html',
  styleUrl: './edgar-info-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, MatButtonModule],
})
export class EdgarInfoSummaryComponent {
  readonly html = input<string>('')
  readonly summary = input<string>('')
  readonly inRequest = input<boolean>(false)

  readonly getReport = output<void>()

  readonly isFullInfo = signal<boolean>(false)

  toggleShowFullInfo(): void {
    this.isFullInfo.update(isFullInfo => !isFullInfo)

    if (!this.html()) {
      this.getReport.emit()
    }
  }
}
